module.exports = __webpack_public_path__ + "assets/4thProportionalDetailed.3622c1af44ac92bd2130988bc0dbcc39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/4thProportionalDetailed.png
// module id = 448
// module chunks = 0